import { VenueAttributes } from '@/types'
import { CreateVenueMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData
  } = useForm<CreateVenueMutation, VenueAttributes, never, never>({
    defaultValues: {
      name: '',
    },
    mutation: CreateMutation,
    resultKey: 'createVenue',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.createVenue?.venue?.id) return

    navigate(`/venues/${mutationData?.createVenue?.venue?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
      <div className="grid grid-cols-3 gap-6">
        { formBuilder.buildField({ name: 'Address Line 1', field: 'address1', type: 'text' }) }
        { formBuilder.buildField({ name: 'Address Line 2', field: 'address2', type: 'text' }) }
        { formBuilder.buildField({ name: 'Address Line 3', field: 'address3', type: 'text' }) }
        { formBuilder.buildField({ name: 'City', field: 'city', type: 'text' }) }
        { formBuilder.buildField({ name: 'County', field: 'county', type: 'text' }) }
        { formBuilder.buildField({ name: 'Postcode', field: 'postcode', type: 'text' }) }
      </div>
      { formBuilder.buildField({ name: 'Notes', field: 'notes', type: 'textarea' }) }

      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
